export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-07A.03542c35.png";